export default __webpack_public_path__ + "static/media/3a8c946c9fc0bbc31b7232417f1c022c1582040750654.60e7e544.webp";